import Vue from "vue";

// 引入组件
import BackTop from "@/components/BackTop.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import NotData from "@/components/NotData.vue";
import Pagination from "@/components/Pagination.vue";
import Tabs from "@/components/Tabs.vue";
import cardUpload from "@/components/cardUpload.vue";
import sliderCheck from "@/components/sliderCheck.vue";
import curriculum from "@/components/course/curriculum.vue";
import evaluate from "@/components/course/evaluate.vue";
import materials from "@/components/course/materials.vue";
import note from "@/components/course/note.vue";
import videoList from "@/components/course/videoList.vue";
import videoNote from "@/components/course/videoNote.vue";
import footer from "@/components/layout/footer.vue";
import header from "@/components/layout/header.vue";
import main from "@/components/layout/main.vue";
import menu from "@/components/layout/menu.vue";
import myMenu from "@/components/layout/myMenu.vue";
import view from "@/components/layout/view.vue";
import answer from "@/components/question/answer.vue";
import answerCart from "@/components/question/answerCart.vue";
import option from "@/components/question/option.vue";
import selectOption from "@/components/question/selectOption.vue";

// 全局注册组件
Vue.component(BackTop.name, BackTop);
Vue.component(ConfirmDialog.name, ConfirmDialog);
Vue.component(NotData.name, NotData);
Vue.component(Pagination.name, Pagination);
Vue.component(Tabs.name, Tabs);
Vue.component(cardUpload.name, cardUpload);
Vue.component(sliderCheck.name, sliderCheck);
Vue.component(curriculum.name, curriculum);
Vue.component(evaluate.name, evaluate);
Vue.component(materials.name, materials);
Vue.component(note.name, note);
Vue.component(videoList.name, videoList);
Vue.component(videoNote.name, videoNote);
Vue.component(footer.name, footer);
Vue.component(header.name, header);
Vue.component(main.name, main);
Vue.component(menu.name, menu);
Vue.component(myMenu.name, myMenu);
Vue.component(view.name, view);
Vue.component(answer.name, answer);
Vue.component(answerCart.name, answerCart);
Vue.component(option.name, option);
Vue.component(selectOption.name, selectOption);
